<template>
<div ref="component" class="custom-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="[{ open: open }, { 'choose': selected !== placeholder }]" @click="open = !open;">
        <span>{{ getSelect }}</span>
        <div v-if="resetBtn" class="reset-btn" :class="{ selectHide: selected === 'Выберите значение' || placeholder }"
            @click.stop="open = false;
            selected = placeholder || 'Выберите значение';
            $emit('input', selected);">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0.410765 0.410704C0.736202 0.0852667 1.26384 0.0852667 1.58928 0.410704L6.00002 4.82145L10.4108 0.410704C10.7362 0.0852667 11.2638 0.0852667 11.5893 0.410704C11.9147 0.736141 11.9147 1.26378 11.5893 1.58921L7.17853 5.99996L11.5893 10.4107C11.9147 10.7361 11.9147 11.2638 11.5893 11.5892C11.2638 11.9147 10.7362 11.9147 10.4108 11.5892L6.00002 7.17847L1.58928 11.5892C1.26384 11.9147 0.736202 11.9147 0.410765 11.5892C0.0853278 11.2638 0.0853278 10.7361 0.410765 10.4107L4.82151 5.99996L0.410765 1.58921C0.0853278 1.26378 0.0853278 0.736141 0.410765 0.410704Z"
                    fill="#252628" />
            </svg>
        </div>
        <div class="expand-btn" @click.stop="open = !open;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path fill="none" stroke="#252628" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2 5l6 6 6-6" />
            </svg>
        </div>
    </div>
    <div class="wrapper" :class="{ selectHide: !open }">
        <div class="items">
            <div v-for="(option, i) of options" :key="i" @click="
                selected = getOption(option); open = false; $emit('input', option)">
                {{ getOption(option) }}
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: 'CustomSelect',
    props: {
        options: {
            type: Array,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
            default: null
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0
        },
        resetBtn: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            // eslint-disable-next-line no-nested-ternary
            selected: this.placeholder ? this.placeholder : (this.options.length > 0 && typeof (this.options[0]) !== 'object') ? this.options[this.tabindex] : this.options[this.tabindex]?.text || this.options[this.tabindex]?.title || 'Выберите значение',
            open: false
        };
    },
    computed: {
        getSelect() {
            return this.selected;
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        // eslint-disable-next-line no-nested-ternary
        const option = this.placeholder ? this.placeholder : (this.options.length > 0 && typeof (this.options[0]) !== 'object') ? this.options[this.tabindex] : this.options[this.tabindex];
        this.$emit('input', option);
    },
    methods: {
        getOption(option) {
            return typeof option === 'object' ? option?.text || option?.title || option?.values : option;
        },
        setSelected(tabindex) {
            this.selected = this.options[tabindex].text;
        },
        handleClickOutside(event) {
            if (this.$refs.component && !this.$refs.component.contains(event.target)) {
                this.open = false;
            }
        },
    }
};
</script>
